<template>
    <div>
        <card-header title="Sessions" icon="fa-users-class"></card-header>

        <card-toolbar>
            <button @click="$openCard('conf-scheduler', {confId: props.confId}, card)"><i class="far fa-calendar-lines-pen"></i>Scheduler</button>
            <button @click="$openCard('conf-new-session', {confId: props.confId}, card)"><i class="far fa-plus"></i>New Session</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <navigation-list-item
                    title="Session Tracks/Topics"
                    icon="fa-code-branch"
                    :active="(child && child.definition.component === 'conf-tracks' && props.confId === parseInt(child.props.confId))"
                    @click="$openCard('conf-tracks', {confId: props.confId}, card)"
                />
                <navigation-list-item
                    title="Session Groups"
                    icon="fa-layer-group"
                    :active="(child && child.definition.component === 'conf-groups' && props.confId === parseInt(child.props.confId))"
                    @click="$openCard('conf-groups', {confId: props.confId}, card)"
                />
                <separator-list-item/>

                <template v-for="(group, key) in sessionsByGroup">
                    <subheader-list-item :title="group[0].conf_session_groups.title" icon="fa-layer-group" class="pb-0"/>
                    <subheader-list-item :title="groupDates(group[0])" icon="" class="pt-0"/>

                    <conf-session-tile
                        :card="card"
                        :session="session"
                        v-for="session in group"
                        :active="(child && child.definition.component === 'conf-session' && session.id === parseInt(child.props.sessionId))"
                        @click="$openCard('conf-session', {confId: session.conference_id, sessionId: session.id}, card)"
                    />
                </template>

                <template v-if="onDemand.length">
                    <subheader-list-item title="On-Demand Sessions" icon="fa-layer-group"/>

                    <conf-session-tile
                        :card="card"
                        :session="session"
                        v-for="session in onDemand"
                        :active="(child && child.definition.component === 'conf-session' && session.id === parseInt(child.props.sessionId))"
                        @click="$openCard('conf-session', {confId: session.conference_id, sessionId: session.id}, card)"
                    />
                </template>

            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";

    import {client as http} from '@/http_client';
    import CardToolbar from "../../../TIER/components/CardToolbar";
    import ConfSessionTile from "../../../components/tiles/ConfSessionTile";
    import SeparatorListItem from "../../../TIER/components/SeparatorListItem";
    import NavigationListItem from "../../../TIER/components/NavigationListItem";
    import SubheaderListItem from "../../../TIER/components/SubheaderListItem.vue";
    import moment from "moment/moment";

    export default {
        components: {SubheaderListItem, NavigationListItem, SeparatorListItem, ConfSessionTile, CardToolbar, CardList, CardHeader, CardBody},
        props: ['card', 'props', 'child'],
        data() {
            return {
                sessions: {},
                onDemand: []
            };
        },
        computed: {
            sessionsByGroup: function() {
                let groups = {};

                if (this.sessions.length) {
                    this.sessions.forEach(session => {
                        if (session.type === 'on_demand') {
                            this.onDemand.push(session);
                        } else {
                            if (!groups[session.conf_session_groups.id]) {
                                groups[session.conf_session_groups.id] = [];
                            }
                            groups[session.conf_session_groups.id].push(session);
                        }
                    });

                    for (let group in groups) {
                        groups[group].sort((a, b) => {
                            return a.start_at - b.start_at;
                        });

                        // sort group array by title
                        groups[group].sort((a, b) => {
                            return a.title.localeCompare(b.title);
                        });
                    }
                }

                // sort on-demand array by title
                this.onDemand.sort((a, b) => {
                    return a.title.localeCompare(b.title);
                });

                return groups;
            }

        },
        methods: {
            loadConference: function(force) {
                this.$emit('loading', true);
                http.get('conferences/' + this.props.confId + '/sessions', {force}).then(response => {
                    this.sessions = response.data;
                    this.onDemand = [];
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            groupDates: function(session) {
                let s = moment(session.start_at);
                let e = moment(session.end_at);

                if (s.isSame(e, 'day')) {
                    return s.format('ddd, MMM D, YYYY h:mm a - ') + e.format('h:mm a');
                } else {
                    return s.format('ddd, MMM D, YYYY h:mm a - ') + e.format('ddd, MMM D, YYYY h:mm a');
                }
            },
            reload: function() {
                this.loadConference(true);
            }
        },
        mounted() {
            this.loadConference();
        }
    };
</script>

<style>

</style>
